module.exports = __webpack_public_path__ + "static/61418163_1286657098166026_5798119576591925248_o_optimized-e447c3dadc9ca7a550c5f968eb4677e1.jpg";